import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Direction, Spacing } from '../../enums';
import { createDataTestId } from '../../utils';
import { responsivePropToArrayOrObject } from '../utils/responsivePropToArrayOrObject';
import { StackItem, StackRoot, StackWrapper } from './Stack.styles';
export function Stack(_ref) {
  let {
    children,
    spacing = Spacing.SPACE_16,
    direction = Direction.COLUMN,
    alignX,
    alignY,
    isWrapped = true,
    itemWidth,
    testId
  } = _ref;
  const spacingArray = responsivePropToArrayOrObject(spacing);
  const directionArray = responsivePropToArrayOrObject(direction);
  const alignXArray = alignX !== undefined ? responsivePropToArrayOrObject(alignX) : undefined;
  const alignYArray = alignY !== undefined ? responsivePropToArrayOrObject(alignY) : undefined;
  const isWrappedArray = responsivePropToArrayOrObject(isWrapped);
  const itemWidthArray = itemWidth !== undefined ? responsivePropToArrayOrObject(itemWidth) : undefined;
  return React.createElement(StackRoot, _extends({
    spacing: spacingArray
  }, createDataTestId(testId), {
    "data-component": "Stack"
  }), React.createElement(StackWrapper, {
    spacing: spacingArray,
    direction: directionArray,
    align: alignXArray,
    isWrapped: isWrappedArray
  }, React.Children.map(children, child => {
    if (child === null) {
      return null;
    }
    return React.createElement(StackItem, {
      direction: directionArray,
      spacing: spacingArray,
      align: alignYArray,
      itemWidth: itemWidthArray,
      "data-component": "Stack"
    }, child);
  })));
}